import { render, staticRenderFns } from "./FactoryEditPage.vue?vue&type=template&id=4dddf0d6&scoped=true&"
import script from "./FactoryEditPage.vue?vue&type=script&lang=ts&"
export * from "./FactoryEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./FactoryEditPage.vue?vue&type=style&index=0&id=4dddf0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dddf0d6",
  null
  
)

export default component.exports